import { api } from '../utils/apiUtils';
import { config } from '../config';

const API_URL = config.API_URI;

/**
 * Fetch all automations for a board
 */
export const fetchAutomations = async (boardId) => {
  try {
    const response = await api.get(`${API_URL}/v1/boards/${boardId}/automations`, { noDedupe: true }, false);
    return response;
  } catch (error) {
    console.error('Error fetching automations:', error);
    throw error;
  }
};

/**
 * Fetch available trigger/action options for the rule builder
 */
export const fetchAutomationOptions = async (boardId) => {
  try {
    const response = await api.get(`${API_URL}/v1/boards/${boardId}/automations/options`, {}, true, 300000);
    return response;
  } catch (error) {
    console.error('Error fetching automation options:', error);
    throw error;
  }
};

/**
 * Create a new automation rule
 */
export const createAutomation = async (boardId, data) => {
  try {
    const response = await api.post(`${API_URL}/v1/boards/${boardId}/automations`, data);
    return response;
  } catch (error) {
    console.error('Error creating automation:', error);
    throw error;
  }
};

/**
 * Update an existing automation rule
 */
export const updateAutomation = async (boardId, automationId, data) => {
  try {
    const response = await api.put(`${API_URL}/v1/boards/${boardId}/automations/${automationId}`, data);
    return response;
  } catch (error) {
    console.error('Error updating automation:', error);
    throw error;
  }
};

/**
 * Delete an automation rule
 */
export const deleteAutomation = async (boardId, automationId) => {
  try {
    const response = await api.delete(`${API_URL}/v1/boards/${boardId}/automations/${automationId}`);
    return response;
  } catch (error) {
    console.error('Error deleting automation:', error);
    throw error;
  }
};

/**
 * Toggle automation enabled/disabled
 */
export const toggleAutomation = async (boardId, automationId) => {
  try {
    const response = await api.patch(`${API_URL}/v1/boards/${boardId}/automations/${automationId}/toggle`, {});
    return response;
  } catch (error) {
    console.error('Error toggling automation:', error);
    throw error;
  }
};

/**
 * Fetch execution logs for an automation
 */
export const fetchAutomationLogs = async (boardId, automationId, page = 1, limit = 20) => {
  try {
    const response = await api.get(
      `${API_URL}/v1/boards/${boardId}/automations/${automationId}/logs?page=${page}&limit=${limit}`,
      { noDedupe: true },
      false
    );
    return response;
  } catch (error) {
    console.error('Error fetching automation logs:', error);
    throw error;
  }
};
